"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboItem = exports.Combobox = void 0;
const react_1 = __importStar(require("react"));
const io_1 = require("react-icons/io");
const react_2 = require("@chakra-ui/react");
exports.Combobox = react_1.default.forwardRef(function Combobox(_a, ref) {
    var { customFilter, inputContainerProps, inputProps, h, options, onChange, onBlur, name, isLoading, isDisabled, loadingText, error, placeholder, bg, value, autoComplete, caseMatter, accentMatter } = _a, rest = __rest(_a, ["customFilter", "inputContainerProps", "inputProps", "h", "options", "onChange", "onBlur", "name", "isLoading", "isDisabled", "loadingText", "error", "placeholder", "bg", "value", "autoComplete", "caseMatter", "accentMatter"]);
    const theme = react_2.useTheme();
    /* Store the input */
    const inputRef = react_1.useRef(null);
    const inRef = react_2.useMergeRefs(ref, inputRef);
    /* Store the root div of the component */
    const rootFlex = react_1.useRef(null);
    /* Store popper and the popper opener */
    const { popperRef, referenceRef } = react_2.usePopper({
        gutter: 0,
        matchWidth: true,
        boundary: "clippingParents",
    });
    /* Store a boolean for the first time the value changes
      after focus
    */
    const valueChanged = react_1.useRef(false);
    /* Merge refs to use them in the same element */
    const rootElement = react_2.useMergeRefs(referenceRef, rootFlex);
    /* Manage the state of the popover */
    const [popoverOpen, setPopoverOpen] = react_1.useState(false);
    /* Manage the current selected option in the combobox */
    const [selected, setSelected] = react_1.useState("");
    const selectChanged = react_1.useRef(false);
    /* Manage the current value of the input */
    const [fieldValue, setFieldValue] = react_1.useState("");
    /* Synchronize with value */
    react_1.useMemo(() => {
        var _a;
        const label = (_a = options.find((opt) => opt.value === value)) === null || _a === void 0 ? void 0 : _a.label;
        if (label) {
            setFieldValue(label);
            setSelected(label);
        }
        else {
            setFieldValue("");
            setSelected("");
            if (onChange) {
                onChange("");
            }
        }
    }, [value]);
    const togglePopover = react_1.useCallback(() => {
        var _a, _b;
        if (popoverOpen) {
            setPopoverOpen(false);
        }
        else {
            setPopoverOpen(true);
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [popoverOpen, setPopoverOpen]);
    const handleFocus = react_1.useCallback(() => {
        var _a, _b;
        setPopoverOpen(true);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.select();
    }, [togglePopover]);
    const handleErase = react_1.useCallback(() => {
        setFieldValue("");
        setSelected("");
        if (onChange) {
            onChange("");
        }
    }, [setSelected, setFieldValue]);
    const handlePopoverItemClick = react_1.useCallback((option) => {
        setFieldValue(option.label);
        setSelected(option.label);
        setPopoverOpen(false);
        selectChanged.current = true;
        if (onChange) {
            onChange(option.value);
        }
    }, [setPopoverOpen, setSelected, setFieldValue]);
    /* Update value state when input change */
    const handleInputChange = react_1.useCallback((event) => {
        setFieldValue(event.target.value);
        valueChanged.current = true;
        if (event.target.value === "") {
            setSelected("");
            if (onChange) {
                onChange("");
            }
        }
        if (!popoverOpen) {
            setPopoverOpen(true);
        }
    }, [selected, setSelected, setFieldValue, setPopoverOpen, popoverOpen]);
    /* Show correct options based on the value state */
    const filteredOptions = options.filter((option) => {
        if (valueChanged.current) {
            let label = option.label;
            let fValue = fieldValue;
            if (!caseMatter) {
                label = label.toLowerCase();
                fValue = fValue.toLowerCase();
            }
            if (!accentMatter) {
                label = label.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                fValue = fValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            }
            return label.includes(fValue);
        }
        else {
            return true;
        }
    });
    const handleInputBlur = react_1.useCallback((event) => {
        setPopoverOpen(false);
        setFieldValue(selected);
        valueChanged.current = false;
        if (onBlur) {
            onBlur(event);
        }
    }, [selected, setPopoverOpen, setFieldValue]);
    return (react_1.default.createElement(react_2.Flex, Object.assign({ bg: "white", position: "relative", onBlur: handleInputBlur, onFocus: handleFocus, 
        //onClick={handleFocus}
        ref: rootElement, w: "100%" }, rest),
        react_1.default.createElement(InputContainer, Object.assign({ h: h, hasValue: fieldValue ? true : false, isLoading: isLoading, loadingText: loadingText, error: error, isDisabled: isDisabled, bg: bg }, inputContainerProps),
            react_1.default.createElement(ComboInput, { autoComplete: autoComplete, isLoading: isLoading, isDisabled: isDisabled, loadingText: loadingText, placeholder: placeholder, disabled: isLoading || isDisabled, name: name, onChange: handleInputChange, onClick: (event) => {
                    setPopoverOpen(true);
                }, height: h, ref: inRef, value: fieldValue }),
            react_1.default.createElement(react_2.Flex, { alignItems: "center", padding: "8px 0px", position: "absolute", right: "4px" },
                fieldValue && (react_1.default.createElement(ComboButton, { disabled: isDisabled || isLoading, className: "close-btn", icon: react_1.default.createElement(io_1.IoIosClose, { fontSize: "1.9rem" }), onClick: handleErase })),
                react_1.default.createElement(ComboButton, { disabled: isDisabled || isLoading, icon: isLoading ? (react_1.default.createElement(react_2.Spinner, { size: "sm", color: "darkgray.200" })) : (react_1.default.createElement(io_1.IoIosArrowDown, { fontSize: "1.4rem", style: {
                            transform: popoverOpen ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform .2s ease-in-out",
                        } })), onClick: togglePopover, onMouseDown: (e) => {
                        e.preventDefault();
                    } }))),
        popoverOpen && (react_1.default.createElement(react_2.Flex, { bg: "white", border: `1px solid ${theme.colors.lightgray[600]}`, borderRadius: "0px", boxShadow: "0px 3px 6px rgba(50, 74, 109, 0.16)", cursor: "pointer", flexDir: "column", maxH: "35vh", overflow: "auto", position: "absolute", bottom: "0px", ref: popperRef, zIndex: 1000 },
            react_1.default.createElement(react_2.Flex, { flexDir: "column", h: "100%", padding: "8px 0px", w: "100%" },
                filteredOptions.length === 0 && (react_1.default.createElement(react_2.Flex, { alignItems: "center", h: "40px", padding: "0px 16px", textAlign: "center", w: "100%" },
                    react_1.default.createElement(react_2.chakra.p, { color: "darkgray.700", fontFamily: "secondary", fontSize: "16px", textStyle: "p" }, "Nenhum resultado encontrado"))),
                filteredOptions.map((option) => (react_1.default.createElement(ComboItem, { isActive: option.label === selected, key: option.id, option: option, onClick: (e) => {
                        handlePopoverItemClick(option);
                    }, onMouseDown: (e) => {
                        e.preventDefault();
                    } }))))))));
});
function ComboItem(_a) {
    var { isActive, option } = _a, rest = __rest(_a, ["isActive", "option"]);
    return (react_1.default.createElement(react_2.Flex, Object.assign({ alignItems: "center", bg: isActive ? "lightgray.500" : "white", cursor: "pointer", h: "40px", padding: "0px 16px", w: "100%", _hover: { bg: isActive ? "lightgray.500" : "lightgray.300" } }, rest),
        react_1.default.createElement(react_2.chakra.p, { color: "darkgray.700", cursor: "pointer", fontFamily: "secondary", fontSize: "16px", textStyle: "p" }, option.label)));
}
exports.ComboItem = ComboItem;
function InputContainer(_a) {
    var { children, h, hasValue, isDisabled, isLoading, loadingText, error } = _a, rest = __rest(_a, ["children", "h", "hasValue", "isDisabled", "isLoading", "loadingText", "error"]);
    const theme = react_2.useTheme();
    /* Define the right padding based on custom height */
    const rightPadding = react_1.useMemo(() => {
        let temp = "36px";
        if (h && hasValue) {
            temp = "calc(2 * h - 20px)";
        }
        else if (hasValue) {
            temp = "72px";
        }
        return temp;
    }, [h, hasValue]);
    return (react_1.default.createElement(react_2.Flex, Object.assign({ alignItems: "center", borderRadius: "8px", bg: "white", borderColor: "lightgray.600", borderWidth: "1px", cursor: "text", height: "tall", justifyContent: "space-between", padding: "8px 16px", paddingRight: rightPadding, position: "relative", sx: {
            ".close-btn": {
                display: "none",
            },
            ":focus-within": {
                border: `1.5px solid ${theme.colors.primary[500]}`,
                boxShadow: `0px 0px 4px ${theme.colors.primary[500]}`,
                ".close-btn": {
                    display: "inline",
                },
            },
            "&:hover .close-btn": {
                display: "inline",
            },
        }, w: "100%", _hover: {
            borderColor: "darkgray.100",
        } }, ((isLoading || isDisabled) && {
        bg: "lightgray.300",
        color: "darkgray.300",
        cursor: "not-allowed",
        _hover: {
            borderColor: "lightgray.600",
        },
    }), (error && {
        borderColor: "danger.600",
        _hover: {
            borderColor: "danger.700",
        },
    }), rest), children));
}
const ComboInput = react_2.forwardRef(function ComboInput(_a, ref) {
    var { autoComplete, height, isLoading, loadingText, placeholder } = _a, rest = __rest(_a, ["autoComplete", "height", "isLoading", "loadingText", "placeholder"]);
    return (react_1.default.createElement(react_2.InputGroup, null,
        react_1.default.createElement(react_2.Input, Object.assign({ autoComplete: autoComplete || "off", color: "darkgray.700", flex: 1, fontFamily: "secondary", fontSize: "sm", fontWeight: "normal", borderRadius: "0px", placeholder: isLoading ? loadingText || "Carregando..." : placeholder, h: "100%", letterSpacing: "sm", lineHeight: "sm", ref: ref, textOverflow: "ellipsis", variant: "unstyled", _disabled: {
                cursor: "not-allowed",
            }, _focus: { outline: "none" }, _placeholder: {
                color: "lightgray.800",
                fontFamily: "secondary",
            } }, rest))));
});
function ComboButton(_a) {
    var { icon, h } = _a, rest = __rest(_a, ["icon", "h"]);
    return (react_1.default.createElement(react_2.Button, Object.assign({ borderRadius: "base", color: "darkgray.600", h: h ? "calc(h - 10px)" : "34px", variant: "unstyled", w: h ? "calc(h - 10px)" : "34px", maxW: "34px", _focus: {
            outline: "none",
        }, _hover: {
            bg: "#12203917",
            color: "darkgray.600",
        } }, rest),
        react_1.default.createElement(react_2.Flex, { alignItems: "center", flex: 1, justifyContent: "center" }, icon)));
}
//# sourceMappingURL=Combobox.js.map